<mat-form-field fxFlexFill appearance="fill">
    <mat-label>Rut</mat-label>
    <input matInput placeholder="12345678-5" [(ngModel)]="this.data" (blur)="onBlur($event)">
</mat-form-field>
